import { Link } from "react-router-dom";
import { Lock, ScanLine, Ruler, Sparkles } from "lucide-react";

export function UpgradeCard({ feature = "This feature" }) {
  return (
    <div className="fadeup max-w-lg mx-auto text-center pm-card p-8" data-testid="upgrade-card">
      <div className="w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ background: "var(--text)" }}>
        <Lock className="w-6 h-6" style={{ color: "#fff" }} />
      </div>
      <h2 className="font-head font-bold text-2xl">{feature} is a member feature</h2>
      <p className="text-sm mt-2" style={{ color: "var(--text-2)" }}>
        Free use includes <b>1 scan</b> and <b>1 measure</b>. To talk it through with the mentor, save paths,
        create invoices, and keep your work, pick a plan.
      </p>
      <div className="flex items-center justify-center gap-4 my-5 text-sm" style={{ color: "var(--text-2)" }}>
        <span className="flex items-center gap-1.5"><ScanLine className="w-4 h-4" /> 1 free scan</span>
        <span className="flex items-center gap-1.5"><Ruler className="w-4 h-4" /> 1 free measure</span>
      </div>
      <Link to="/paywall" className="pm-btn inline-flex items-center gap-2" data-testid="upgrade-btn">
        <Sparkles className="w-4 h-4" /> See plans
      </Link>
    </div>
  );
}

export function UpgradeBanner() {
  return (
    <div className="pm-card p-4 flex items-center justify-between gap-3 flex-wrap" data-testid="upgrade-banner"
      style={{ borderColor: "var(--text)" }}>
      <div className="flex items-center gap-2 text-sm">
        <Sparkles className="w-4 h-4" />
        <span><b>Free preview.</b> You get 1 scan and 1 measure. Unlock the mentor, paths, invoices & saving.</span>
      </div>
      <Link to="/paywall" className="pm-btn text-sm whitespace-nowrap" data-testid="banner-upgrade-btn">See plans</Link>
    </div>
  );
}
